var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content && _vm.content.content && _vm.content.content.items)?_c('g-highlight-slideshow',{attrs:{"content":{
    title: 'Highlight',
    items: _vm.content.content.items,
  }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }